import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { withFirebase } from "../../components/Firebase/Firebase";
import Input from "../../components/Input/Input";
import TwoColumns from "../../components/TwoColumns/TwoColumns";
import FormActions from "../../components/FormActions/FormActions";
import Button from "../../components/Button/Button";
import { competitionStates } from "../../config";

import "./CompetitionEdit.css";

class CompetitionEdit extends Component {
  state = {
    name: "",
    url: "",
    state: ""
  };

  componentDidMount() {
    // Check if we already have data
    if (this.props.id) {
      this.setState({
        ...this.props.competitions[this.props.id]
      });
    }
  }

  handleInputEvent = (e, key) => {
    this.setState({
      [key]: e.target.value
    });
  };

  cancel = () => {
    this.props.history.push("/admin/competitions");
  };

  save = async () => {
    if (this.props.id) {
      await this.props.methods.updateCompetition(this.props.id, {
        name: this.state.name,
        state: this.state.state,
        url: this.state.url
      });
      this.props.history.push("/admin/competitions");
    } else {
      await this.props.methods.newCompetition({
        name: this.state.name,
        state: this.state.state,
        url: this.state.url
      });
      this.props.history.push("/admin/competitions");
    }
  };

  render() {
    return (
      <div>
        <div className="CompetitionEdit">
          <TwoColumns
            left={
              <div>
                <Input
                  title="Name"
                  value={this.state.name}
                  onChange={e => this.handleInputEvent(e, "name")}
                />
                <Input
                  title="State"
                  value={this.state.state}
                  type="dropdown"
                  options={{
                    "": "Select One",
                    ...competitionStates
                  }}
                  onChange={e => this.handleInputEvent(e, "state")}
                />
              </div>
            }
            right={
              <div>
                <Input
                  title="URL Path"
                  value={this.state.url}
                  onChange={e => this.handleInputEvent(e, "url")}
                />
              </div>
            }
          />
        </div>
        <FormActions
          left={<div />}
          right={
            <div>
              <Button onClick={this.cancel}>Cancel</Button>
              <Button onClick={this.save}>Save</Button>
            </div>
          }
        />
      </div>
    );
  }
}

export default withRouter(withFirebase(CompetitionEdit));



// WEBPACK FOOTER //
// ./src/components/CompetitionEdit/CompetitionEdit.js